export interface AudioControllerPlayer {
  readonly muted: boolean;
  readonly volume: number;
  pause(): void;
}

class AudioController {
  private static instance: AudioController | null = null;

  private activeAudioInstance: AudioControllerPlayer | null = null;

  onMediaPlay(mediaPlayer: AudioControllerPlayer) {
    if (!mediaPlayer.muted && mediaPlayer.volume > 0 && this.activeAudioInstance !== mediaPlayer) {
      this.activeAudioInstance?.pause();
      this.activeAudioInstance = mediaPlayer;
    }
  }

  onDestroy(mediaPlayer: AudioControllerPlayer) {
    if (this.activeAudioInstance === mediaPlayer) {
      this.activeAudioInstance = null;
    }
  }

  static get audioController() {
    if (!AudioController.instance) {
      AudioController.instance = new AudioController();
    }

    return AudioController.instance;
  }
}

export const audioController = AudioController.audioController;
export type { AudioController };
